import { authAction } from "./auth/authAction";
import { baoCaoActions } from "./bao-cao/baoCaoActions";
import { bienLaiPagingActions } from "./bien-lai/bienLaiPagingActions";
import { bienLaiViewActions } from "./bien-lai/bienLaiViewActions";
import { bienLaiViewChiTietActions } from "./bien-lai/bienLaiViewChiTietActions";
import { bienLaiViewTheoLopActions } from "./bien-lai/bienLaiViewTheoLopActions";
import { bienLaiViewTheoLopChiTietActions } from "./bien-lai/bienLaiViewTheoLopChiTietActions";
import { bienLaiViewTuyenSinhActions } from "./bien-lai/bienLaiViewTuyenSinhActions";
import { bieuDoActions } from "./bieu-do/bieuDoActions";
import { bienLaiThietLapActions } from "./category/bienLaiThietLapActions";
import { bsktDotHocActions } from "./category/bsktDotHocActions";
import { chuongTrinhDaoTaoKienThucActions } from "./category/chuongTrinhDaoTaoKienThucActions";
import { chuyenNganhActions } from "./category/chuyenNganhActions";
import { configInvoiceActions } from "./category/configInvoiceActions";
import { coSoActions } from "./category/coSoActions";
import { danhBaSinhVienActions } from "./category/danhBaSinhVienActions";
import { doiTuongKhongTinhHocPhiActions } from "./category/doiTuongKhongTinhHocPhiActions";
import { dotTuyenSinhActions } from "./category/dotTuyenSinhActions";
import { heActions } from "./category/heActions";
import { hinhThucNopTienActions } from "./category/hinhThucNopTienActions";
import { hocKyDangKyActions } from "./category/hocKyDangKyActions";
import { keHoachNamActions } from "./category/keHoachNamActions";
import { khoaActions } from "./category/khoaActions";
import { khoiNganhActions } from "./category/khoiNganhActions";
import { loaiThuBoSungKienThucActions } from "./category/loaiThuBoSungKienThucActions";
import { loaiThuChiActions } from "./category/loaiThuChiActions";
import { loaiThuNhapHocActions } from "./category/loaiThuNhapHocActions";
import { loaiThuTuyenSinhActions } from "./category/loaiThuTuyenSinhActions";
import { lePhiBuocNhayActions } from "./category/lePhiBuocNhayActions";
import { lopNamHocActions } from "./category/lopNamHocActions";
import { monHocActions } from "./category/monHocActions";
import { monKhongTinhHocPhiActions } from "./category/monKhongTinhHocPhiActions";
import { mucHocPhiTinChiActions } from "./category/mucHocPhiTinChiActions";
import { nganhActions } from "./category/nganhActions";
import { nhomloaiThuChiActions } from "./category/nhomLoaiThuChiActions";
import { quocTichActions } from "./category/quocTichActions";
import { mucHocPhiTheoMonActions } from "./category/mucHocPhiTheoMonActions";
import { mucHocPhiTheoCTDTActions } from "./category/mucHocPhiTheoCTDTActions";
import { quyDoiTyGiaActions } from "./category/quyDoiTyGiaActions";
import { trangThaiHocActions } from "./category/trangThaiHocActions";
import { tsNganhXetTuyenActions } from "./category/tsNganhXetTuyenActions";
import { voucherActions } from "./category/voucherActions";
import { layoutActions } from "./common/layoutActions";
import { dichVuHoSoActions } from "./dich-vu/dichVuHoSoActions";
import { dichVuThanhToanActions } from "./dich-vu/dichVuThanhToanActions";
import { dichVuThongTinActions } from "./dich-vu/dichVuThongTinActions";
import { dongBoCongNoActions } from "./dong-bo/dongBoCongNoActions";
import { dongBoHocPhiActions } from "./dong-bo/dongBoHocPhiActions";
import { dongBoPhiKyTucXaActions } from "./dong-bo/dongBoPhiKyTucXaActions";
import { gachNoThuCongActions } from "./dong-bo/gachNoThuCongActions";
import { hoaDonDienTuActions } from "./hoa-don/hoaDonDienTuActions";
import { kyHieuHoaDonActions } from "./hoa-don/kyHieuHoaDonActions";
import { danhSachLopTinChiActions } from "./lop-tin-chi/danhSachLopTinChiActions";
import { planLopTinChiActions } from "./lop-tin-chi/planLopTinChiActions";
import { danhSachMienGiamActions } from "./mien-giam/danhSachMienGiamActions";
import { danhSachTroCapActions } from "./tro-cap/danhSachTroCapActions";
import { hinhThucActions } from "./mien-giam/hinhThucActions";
import { hinhThucChiTietActions } from "./mien-giam/hinhThucChiTietActions";
import { hinhThucTinhActions } from "./mien-giam/hinhThucTinhActions";
import { mucThuActions } from "./muc-thu/mucThuActions";
import { mucThuTamThuActions } from "./muc-thu/mucThuTamThuActions";
import { mucThuTinChiActions } from "./muc-thu/mucThuTinChiActions";
import nganHangActions from "./ngan-hang/nganHangActions";
import { nofiticationActions } from "./nofitication/nofiticationActions";
import { reportActions } from "./report/reportActions";
import { reportNhapHocActions } from "./report/reportNhapHocActions";
import { reportTuyenSinhActions } from "./report/reportTuyenSinhActions";
import { reportTamThuActions } from "./report/reportTamThuActions";
import { tongHopSinhVienActions } from "./report/tongHopSinhVienActions";
import { heSoLopTuNguyenActions } from "./thiet-lap/heSoLopTuNguyenActions";
import { thuPhiNhapHocActions } from "./thu-phi-nhap-hoc/thuPhiActions";
import { thuPhiTamThuActions } from "./thu-phi-tam-thu/thuPhiActions";
import { importTuyenSinhActions } from "./thu-phi-tuyen-sinh/importActions";
import { thuPhiTuyenSinhActions } from "./thu-phi-tuyen-sinh/thuPhiActions";
import { thuPhiActions } from "./thu-phi/thuPhiActions";
import { thuPhiTheoLopActions } from "./thu-phi/thuPhiTheoLopActions";

export const rootActions = {
  auth: authAction,
  common: {
    layout: layoutActions,
  },
  category: {
    loaiThuChi: loaiThuChiActions,
    mucHocPhiTinChi: mucHocPhiTinChiActions,
    mucHocPhiTheoMon: mucHocPhiTheoMonActions,
    mucHocPhiTheoCTDT: mucHocPhiTheoCTDTActions,
    chuyenNganh: chuyenNganhActions,
    keHoachNam: keHoachNamActions,
    nganh: nganhActions,
    he: heActions,
    lopNamHoc: lopNamHocActions,
    nhomLoaiThuChi: nhomloaiThuChiActions,
    chuongTrinhDaoTaoKienThuc: chuongTrinhDaoTaoKienThucActions,
    hinhThucNopTien: hinhThucNopTienActions,
    hocKyDangKy: hocKyDangKyActions,
    khoa: khoaActions,
    bienLaiThietLap: bienLaiThietLapActions,
    dotTuyenSinh: dotTuyenSinhActions,
    loaiThuNhapHoc: loaiThuNhapHocActions,
    loaiThuBoSungKienThuc: loaiThuBoSungKienThucActions,
    loaiThuTuyenSinh: loaiThuTuyenSinhActions,
    lePhiBuocNhay: lePhiBuocNhayActions,
    coSo: coSoActions,
    khoiNganh: khoiNganhActions,
    voucher: voucherActions,
    configInvoice: configInvoiceActions,
    trangThaiHoc: trangThaiHocActions,
    tsNganhXetTuyen: tsNganhXetTuyenActions,
    quocTich: quocTichActions,
    danhBaSinhVien: danhBaSinhVienActions,
    monKhongTinhHocPhi: monKhongTinhHocPhiActions,
    doiTuongKhongTinhHocPhi: doiTuongKhongTinhHocPhiActions,
    monHoc: monHocActions,
    quyDoiTyGia: quyDoiTyGiaActions,
    bsktDotHoc: bsktDotHocActions,
  },
  nganHang: {
    nganHang: nganHangActions,
  },
  mucThu: {
    mucThu: mucThuActions,
    mucThuTinChi: mucThuTinChiActions,
    mucthuTamThu: mucThuTamThuActions,
  },
  mienGiam: {
    hinhThuc: hinhThucActions,
    hinhThucChiTiet: hinhThucChiTietActions,
    hinhThucTinh: hinhThucTinhActions,
    danhSachMienGiam: danhSachMienGiamActions,
  },
  troCap: {
    danhSachTroCap: danhSachTroCapActions,
  },
  thuPhi: {
    thuPhi: thuPhiActions,
    thuPhiTheoLop: thuPhiTheoLopActions,
    thuPhiNhapHoc: thuPhiNhapHocActions,
    thuPhiTuyenSinh: thuPhiTuyenSinhActions,
    importTuyenSinh: importTuyenSinhActions,
    thuPhiTamThu: thuPhiTamThuActions,
  },
  bienLai: {
    bienLaiView: bienLaiViewActions,
    bienLaiViewTuyenSinh: bienLaiViewTuyenSinhActions,
    bienLaiViewTheoLop: bienLaiViewTheoLopActions,
    bienLaiViewChiTiet: bienLaiViewChiTietActions,
    bienLaiViewTheoLopChiTiet: bienLaiViewTheoLopChiTietActions,
    bienLaiPaging: bienLaiPagingActions,
  },
  hoaDon: {
    hoaDonDienTu: hoaDonDienTuActions,
    kyHieuHoaDon: kyHieuHoaDonActions,
  },
  report: {
    report: reportActions,
    reportNhapHoc: reportNhapHocActions,
    reportTuyenSinh: reportTuyenSinhActions,
    reportTamThu: reportTamThuActions,
    sinhVien: tongHopSinhVienActions,
  },
  lopTinChi: {
    planLopTinChi: planLopTinChiActions,
    danhSachLoptinChi: danhSachLopTinChiActions,
  },
  baoCao: {
    baoCao: baoCaoActions,
  },
  bieuDo: {
    bieuDo: bieuDoActions,
  },
  dongBo: {
    hocPhi: dongBoHocPhiActions,
    kyTucXa: dongBoPhiKyTucXaActions,
    congNo: dongBoCongNoActions,
    gachNoThuCong: gachNoThuCongActions,
  },
  thietLap: {
    heSoLopTuNguyen: heSoLopTuNguyenActions,
  },
  dichVu: {
    hoSo: dichVuHoSoActions,
    thanhToan: dichVuThanhToanActions,
    thongTin: dichVuThongTinActions,
  },
  nofitication: {
    nofitication: nofiticationActions,
  },
};
